import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Card,
  Modal,
  DatePicker,
  Button,
  Input,
  Checkbox,
  Spin
} from "antd";

//import { Input as InputDsGov, Button, Group, Card as CardDsGov, Row, Col as ColDsgov } from "react-dsgov";

import { errorMessage, successMessage } from "../../../messages/messages";

import { disabledDate, isStateValid, isValidNup, onlyNumbers, pushToBase } from "../../../utils/utilsFunctions";
import SelecionarPessoaJuridica from "../../../components/SelecionarPessoaJuridica";
import type { IAutorizacaoPlano, IEfpc, IPessoaJuridica } from "../../../components/Interfaces";
import { CheckOutlined } from "@ant-design/icons";
import { maskNumeroProcesso } from "../../../utils/maskFunctions";
import type { CheckboxProps } from "antd/lib";
import { PatternFormat } from "react-number-format";
import { useLocation, useNavigate } from "react-router";
import dayjs from "dayjs";
import { apiPrimarias } from "../../../services/api";
import TextArea from "antd/es/input/TextArea";

const OperacaoAutorizacaoPlano: React.FC<any> = () => {

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { state } = useLocation();


  const [efpcRequerente, setEfpcRequerente] = useState<IEfpc>();
  //  const [operacaoSelecionada, setOperacaoSelecionada] = useState<IOperacaoEfpc>();
  const [pessoaJuridicaPlano, setPessoaJuridicaPlano] = useState<IPessoaJuridica>();
  const [numeroProcessoNovaPjPlano, setNumeroProcessoNovaPjPlano] = useState("");
  const [razaoSocial, setRazaoSocial] = useState("");
  const [cadastrarPessoaJuridicaSomenteComNumeroProcesso, setCadastrarPessoaJuridicaSomenteComNumeroProcesso] = useState(false);

  const [modalAutorizacaoAberto, setModalAutorizacaoAberto] = useState(false);

  const [loading, setLoading] = useState(false);
  const [tipLoading, _setTipLoading] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0)
    if (isStateValid(state)) {
      validarEfpcRequerente(state.data);
    } else {
      errorMessage("Não foi possível identificar as operações de autorização da Entidade.");
      pushToBase(navigate);
    }
  }, []);

  useEffect(() => {
    if (efpcRequerente) {
      form.setFieldsValue({
        operacaoRazaoSocialEfpcRequerente: efpcRequerente?.pessoaJuridicaEfpc?.razaoSocial,
        operacaoSiglaEfpcRequerente: efpcRequerente.sigla,
        operacaoCodigoEfpcRequerente: efpcRequerente.numero
      });
    }
  }, [efpcRequerente]);

  function validarEfpcRequerente(efpcReq: IEfpc) {
    if (!efpcReq || !efpcReq.serie || efpcReq.serie <= 0) {
      errorMessage("Entidade Requerente não identificada");
      pushToBase(navigate);
    } else {
      setEfpcRequerente(efpcReq);
    }
  }

  useEffect(() => {
    if (pessoaJuridicaPlano) {
      setRazaoSocial(pessoaJuridicaPlano.razaoSocial);
    }
  }, [pessoaJuridicaPlano]);

  function pushToEfpcOperacoes() {
    let tpSelecao = {
      data: efpcRequerente,
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/operacao-efpc", { state: tpSelecao });
  }

  const planoAutorizacaoRequerer = async (efpcRequerente: IEfpc, numeroPessoaJuridicaPlanoOuProcesso: string) => {
    setLoading(true);
    const currentForm = form.getFieldsValue();

    const jsonRequisicao: IAutorizacaoPlano =
    {
      serieEfpc: efpcRequerente.serie || -1,
      numeroEfpcRequerente: efpcRequerente.numero,
      numeroPessoaJuridicaObjeto: !cadastrarPessoaJuridicaSomenteComNumeroProcesso ? onlyNumbers(numeroPessoaJuridicaPlanoOuProcesso) : undefined,
      numeroProcessoObjeto: cadastrarPessoaJuridicaSomenteComNumeroProcesso ? onlyNumbers(numeroPessoaJuridicaPlanoOuProcesso) : undefined,
      razaoSocialObjeto: razaoSocial,
      dataPosicao: currentForm.dataPosicao ? dayjs(currentForm.dataPosicao).format('YYYY-MM-DDTHH:mm:ss') : "",
      justificativa: currentForm.justificativa,
    }

    //console.log("json subindo");
    //console.log(jsonRequisicao);

    try {
      let query = `/plano-de-beneficios/autorizacao/requerer`;

      await apiPrimarias.post(query, jsonRequisicao);

      successMessage(
        `Operação de Autorização de Plano de Benefícios cadastrada com Sucesso`
      );

      pushToEfpcOperacoes();

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    } finally {
      setModalAutorizacaoAberto(false);
      setLoading(false);
    }
  };


  const onChangeCadastroPorProcesso: CheckboxProps['onChange'] = (e) => {
    setCadastrarPessoaJuridicaSomenteComNumeroProcesso(e.target.checked);
  };

  return (
    <Spin spinning={loading} tip={tipLoading}>
      <Form layout="vertical" form={form}>

        <Modal title="Requisição de Autorização de Plano de Benefício por Entidade"

          open={modalAutorizacaoAberto}
          onOk={() => {
            if (!cadastrarPessoaJuridicaSomenteComNumeroProcesso) {
              if (efpcRequerente && efpcRequerente.numero !== ""
                && pessoaJuridicaPlano && pessoaJuridicaPlano.numero !== "")
                // pushToPlanoCadastrar();
                planoAutorizacaoRequerer(efpcRequerente, pessoaJuridicaPlano.numero)
              else
                errorMessage("Número (CNPJ, NIF, Processo) da Pessoa Jurídica não localizada.");
            } else {
              if (!numeroProcessoNovaPjPlano) {
                errorMessage("O Número do Processo é obrigatório.");
                return;
              } else if (!isValidNup(numeroProcessoNovaPjPlano)) {
                errorMessage("Número do Processo inválido.");
                return;
              } else {
                if (efpcRequerente) {
                  // pushToPlanoCadastrar();
                  planoAutorizacaoRequerer(efpcRequerente, numeroProcessoNovaPjPlano)
                } else {
                  errorMessage("Número (CNPJ, NIF, Processo) da Pessoa Jurídica não localizada.");
                }
              }
            }
          }}
          onCancel={() => setModalAutorizacaoAberto(false)}
        >
          <p>Requisitante: {efpcRequerente?.pessoaJuridicaEfpc?.razaoSocial} </p>
          <p>Plano de Benefício: {razaoSocial} </p>

          <Row>
            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Data da Requisição"
                name="dataPosicao"
                rules={[
                  {
                    required: true,
                    message: "Preencha da Data de Vigência",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={24}>
              <Form.Item
                label="Justificativa da Autorização"
                name="justificativa"
                rules={[
                  {
                    required: true,
                    message: "Preencha a justificativa da Autorização",
                  },
                ]}
              >
                <TextArea />
              </Form.Item>
            </Col>
          </Row>
        </Modal>


        <Card>
          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações da Entidade Requerente da Autorização do Plano de Benefícios</h2>
          </div>

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label="Código"
                name="operacaoCodigoEfpcRequerente">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="####-#" />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item label="Sigla"
                name="operacaoSiglaEfpcRequerente">
                <Input disabled={true} />
              </Form.Item>
            </Col>


            <Col xs={24} xl={12}>
              <Form.Item label="Razão Social"
                name="operacaoRazaoSocialEfpcRequerente">
                <Input disabled={true} />
              </Form.Item>
            </Col>

          </Row>
        </Card>

        <Checkbox onChange={onChangeCadastroPorProcesso}>Cadastrar Pessoa Jurídica nova Somente com Número do Processo</Checkbox>;
      </Form><Card hidden={cadastrarPessoaJuridicaSomenteComNumeroProcesso}>
        <div className="main-content pl-sm-3 mt-4">
          <h2>Seleção da Pessoa Jurídica do Plano de Benefícios</h2>
        </div>
        <SelecionarPessoaJuridica
          textoBotao="Consultar Pessoa Jurídica Plano de Benefícios"
          setPessoaJuridica={setPessoaJuridicaPlano} />
      </Card><Form layout="vertical" form={form}>
        <Card hidden={!cadastrarPessoaJuridicaSomenteComNumeroProcesso}>
          <div className="main-content pl-sm-3 mt-4">
            <h2>Informação do Número do Processo</h2>
          </div>
          <Row>
            <Col xs={24} xl={10}>
              <Form.Item
                label="Número do Processo"
                name='numeroProcessoInformado'
                rules={[
                  {
                    required: cadastrarPessoaJuridicaSomenteComNumeroProcesso,
                    message: "O número do processo é Obrigatório",
                  },
                ]}
              >
                <Input
                  maxLength={20}
                  onChange={(e) => {
                    setNumeroProcessoNovaPjPlano(onlyNumbers(e.target.value));
                    form.setFieldsValue({
                      numeroProcessoInformado: maskNumeroProcesso(e.target.value),
                    });
                  }} />
              </Form.Item>
            </Col>
            <Col xs={24} xl={15}>
              <Form.Item
                label='Nome Empresarial'
                name='razaoSocial'
                rules={[
                  {
                    required: cadastrarPessoaJuridicaSomenteComNumeroProcesso,
                    message: "Razão Social é Obrigatório",
                  },
                ]}
              >
                <Input
                  maxLength={100}
                  onChange={(e) => setRazaoSocial(e.target.value)} />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>

      <Row>
        {<>
          <Button shape='round'
            disabled={!efpcRequerente || !razaoSocial || !cadastrarPessoaJuridicaSomenteComNumeroProcesso ? !pessoaJuridicaPlano : !numeroProcessoNovaPjPlano}
            type='primary' icon={<CheckOutlined />} htmlType='button'
            onClick={() => {
              if (!efpcRequerente || efpcRequerente.numero === "") {
                errorMessage("Pessoa Jurídica do requerente não identificada.");
                return;
              }

              if (!cadastrarPessoaJuridicaSomenteComNumeroProcesso &&
                (!pessoaJuridicaPlano || pessoaJuridicaPlano.numero === "")) {
                errorMessage("Pessoa Jurídica da Entidade não identificada.");
                return;
              }

              if (cadastrarPessoaJuridicaSomenteComNumeroProcesso) {
                if (!numeroProcessoNovaPjPlano || numeroProcessoNovaPjPlano === "") {
                  errorMessage("O Número do Processo é obrigatório.");
                  return;
                }
                if (numeroProcessoNovaPjPlano && !isValidNup(numeroProcessoNovaPjPlano)) {
                  errorMessage("Número do Processo inválido.");
                  return;
                }
              }
              setModalAutorizacaoAberto(true);
            }}>
            Cadastrar Operação
          </Button>

        </>}
      </Row>
    </Spin>

  );
};

export default OperacaoAutorizacaoPlano;
